export default __webpack_public_path__ + "fbe5b959c5ec4b3aea84e5891e8d8645.ico";